import React, { Component } from 'react';

class ReactFaqList extends Component {
  constructor(props) {
    super();
    this.state = {
      data: [],
      question: '',
      answer: '',
      answerStyles: {},
      questionStyles: {},
      answerClass: '',
      questionClass: ''
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.questionKeyName === undefined || props.questionKeyName.length < 1) {
      console.error('Please set value for questionKeyName');
      return null;
    } else if (props.answerKeyName === undefined || props.answerKeyName.length < 1) {
      console.error('Please set value for answerKeyName');
      return null;
    } else if (JSON.stringify(props.data) !== JSON.stringify(state.data)) {
      if (Object.keys(props.answerStyles).length > 0 && Object.keys(props.questionStyles).length > 0) {
        return {
          data: props.data,
          question: props.questionKeyName,
          answer: props.answerKeyName,
          answerStyles: props.answerStyles,
          questionStyles: props.questionStyles,
          answerClass: props.answerClass,
          questionClass: props.questionClass
        };
      } else {
        console.warn('Styles objects are empty');
        return {
          data: props.data,
          question: props.questionKeyName,
          answer: props.answerKeyName
        };
      }
    } else {
      return null;
    }
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "InputSuggestionClass"
    }, this.state.data.map((val, i) => {
      return /*#__PURE__*/React.createElement("details", {
        key: i,
        style: {
          marginBottom: '1%'
        }
      }, /*#__PURE__*/React.createElement("summary", {
        style: this.state.questionStyles,
        className: this.state.questionFaqList
      }, val[this.state.question]), /*#__PURE__*/React.createElement("p", {
        className: this.state.answerClass,
        style: this.state.answerStyles
      }, val[this.state.answer]));
    }));
  }

}

export default ReactFaqList;